import {
    CREATE_CUTTING_INWARD_MASTER_REQUEST_DK,
    CREATE_CUTTING_INWARD_MASTER_SUCCESS_DK,
    CREATE_CUTTING_INWARD_MASTER_FAILURE_DK,
    DELETE_CUTTING_INWARD_MASTER_REQUEST_DK,
    DELETE_CUTTING_INWARD_MASTER_SUCCESS_DK,
    DELETE_CUTTING_INWARD_MASTER_FAILURE_DK,
    FETCH_SINGLE_CUTTING_INWARD_MASTER_REQUEST_DK,
    FETCH_SINGLE_CUTTING_INWARD_MASTER_SUCCESS_DK,
    FETCH_SINGLE_CUTTING_INWARD_MASTER_FAILURE_DK,
    FETCH_CUTTING_INWARD_MASTER_REQUEST_DK,
    FETCH_CUTTING_INWARD_MASTER_SUCCESS_DK,
    FETCH_CUTTING_INWARD_MASTER_FAILURE_DK,
    UPDATE_CUTTING_INWARD_MASTER_REQUEST_DK,
    UPDATE_CUTTING_INWARD_MASTER_SUCCESS_DK,
    UPDATE_CUTTING_INWARD_MASTER_FAILURE_DK,
    RESET_CUTTING_INWARD_MASTER_INFO_DK,
    CREATE_CUTTING_INWARD_MASTER_FORM_DK,
    UPDATE_CUTTING_INWARD_MASTER_FORM_DK,
    NAVIGATE_CUTTING_INWARD_DETAILS_DK,
    NAVIGATE_CUTTING_INWARD_MASTER_DK,
    FETCH_PENDING_CUTTING_PO_IN_INWARD_REQUEST_DK,
    FETCH_PENDING_CUTTING_PO_IN_INWARD_SUCCESS_DK,
    FETCH_PENDING_CUTTING_PO_IN_INWARD_FAILURE_DK,
    SET_ACTIVE_KEY_CUTTING_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_CUTTING_INWARD_ID_DK,
    FETCH_CUTTING_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK,
    FETCH_CUTTING_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK,
    FETCH_CUTTING_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK,
    RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID_DK,
    CREATE_CUTTING_INWARD_EDIT_QTY_MASTER_REQUEST_DK,
    CREATE_CUTTING_INWARD_EDIT_QTY_MASTER_SUCCESS_DK,
    CREATE_CUTTING_INWARD_EDIT_QTY_MASTER_FAILURE_DK,
    RESET_CUTTING_INWARD_RESPONSE_DK,
    SET_PENDING_GRID_NAME_CUTTING_INWARD_DK,
    SET_UNIT_NAME_CUTTING_INWARD_DK,
    FETCH_COMPLETE_CUTTING_DC_IN_INWARD_REQUEST_DK,
    FETCH_COMPLETE_CUTTING_DC_IN_INWARD_SUCCESS_DK,
    FETCH_COMPLETE_CUTTING_DC_IN_INWARD_FAILURE_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK,
    FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK
} from './cuttingInwardHeader.actionsType';

export const CUTTING_INWARD_DK_MASTER = 'cuttingInwardDKHeader';

let initialState = {
    loading: false,
    cuttingInwardHeader: [],
    cuttingInwardHeaderEditQuantity: [],
    completeCuttingDc:[],
    reportSingleCuttProgramInwardList:[],
    pendingCuttingDc: [],
    activeKey: 1,
    cuttingInwardId: '',
    detailsId: [],
    styleData: {},
    cuttingInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierDCValue: null,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldDiscountPercentage: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedState: {},
    renderGridBtn: 'pendingGrid',
    unitId: '',
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    errorMessage: '',
    singleCuttingInwardData: {},
    isCuttingInwardDetails: false
};

export let cuttingInwardDKHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CUTTING_INWARD_MASTER_REQUEST_DK:
        case FETCH_CUTTING_INWARD_MASTER_EDIT_QUANTITY_REQUEST_DK:
        case FETCH_PENDING_CUTTING_PO_IN_INWARD_REQUEST_DK:
        case CREATE_CUTTING_INWARD_MASTER_REQUEST_DK:
        case CREATE_CUTTING_INWARD_EDIT_QTY_MASTER_REQUEST_DK:
        case UPDATE_CUTTING_INWARD_MASTER_REQUEST_DK:
        case FETCH_SINGLE_CUTTING_INWARD_MASTER_REQUEST_DK:
        case DELETE_CUTTING_INWARD_MASTER_REQUEST_DK:
        case FETCH_COMPLETE_CUTTING_DC_IN_INWARD_REQUEST_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_CUTTING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardHeader: updatePayload
            };
        case FETCH_CUTTING_INWARD_MASTER_EDIT_QUANTITY_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardHeaderEditQuantity: updatePayload?.CUD,
                activeKey: 2
            };
        case FETCH_PENDING_CUTTING_PO_IN_INWARD_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                pendingCuttingDc: updatePayload
            };
        case CREATE_CUTTING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                cuttingInwardId: payload[0]?.fldID,
                detailsId: payload,
                activeKey: 2
            };
            case FETCH_COMPLETE_CUTTING_DC_IN_INWARD_SUCCESS_DK:
                return {
                    ...state,
                    loading: false,
                    completeCuttingDc: updatePayload
                };
                case FETCH_SINGLE_DATA_FOR_REPORT_SUCCESS_DK:
                    return {
                        ...state,
                        loading: false,
                        reportSingleCuttProgramInwardList: updatePayload
                    };
        case CREATE_CUTTING_INWARD_EDIT_QTY_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                activeKey: 1,
                detailsId: []
            };
        case UPDATE_CUTTING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_CUTTING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_CUTTING_INWARD_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case RESET_CUTTING_INWARD_MASTER_INFO_DK:
            return {
                ...state,
                cuttingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                // cuttingInwardId: '',
                styleData: {},
                activeKey: 1
                // detailsId: []
            };
        case CREATE_CUTTING_INWARD_MASTER_FORM_DK:
        case UPDATE_CUTTING_INWARD_MASTER_FORM_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardHeaderForm: {
                    ...state.cuttingInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_CUTTING_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: 1
            };
        case RESET_EDIT_QUANTITY_GRID_DATA_WITHOUT_CUTTING_INWARD_ID_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardHeaderEditQuantity: [],
                detailsId: []
            };
        case FETCH_CUTTING_INWARD_MASTER_FAILURE_DK:
        case FETCH_CUTTING_INWARD_MASTER_EDIT_QUANTITY_FAILURE_DK:
        case FETCH_PENDING_CUTTING_PO_IN_INWARD_FAILURE_DK:
        case CREATE_CUTTING_INWARD_MASTER_FAILURE_DK:
        case CREATE_CUTTING_INWARD_EDIT_QTY_MASTER_FAILURE_DK:
        case UPDATE_CUTTING_INWARD_MASTER_FAILURE_DK:
        case FETCH_SINGLE_CUTTING_INWARD_MASTER_FAILURE_DK:
        case DELETE_CUTTING_INWARD_MASTER_FAILURE_DK:
        case FETCH_COMPLETE_CUTTING_DC_IN_INWARD_FAILURE_DK:
        case FETCH_SINGLE_DATA_FOR_REPORT_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        case RESET_FORM_DATA_WITHOUT_CUTTING_INWARD_ID_DK:
            return {
                ...state,
                cuttingInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierDCValue: null,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldDiscountPercentage: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedTeam: {}
            };
            case SET_PENDING_GRID_NAME_CUTTING_INWARD_DK:
                return {
                    ...state,
                    renderGridBtn: payload
                };
            case SET_UNIT_NAME_CUTTING_INWARD_DK:
                return {
                    ...state,
                    unitId: payload
                };
        case NAVIGATE_CUTTING_INWARD_DETAILS_DK:
            return {
                ...state,
                isCuttingInwardDetails: true,
                singleCuttingInwardData: updatePayload.singleCuttingInwardData
            };
        case NAVIGATE_CUTTING_INWARD_MASTER_DK:
            return {
                ...state,
                isCuttingInwardDetails: false
            };
        default:
            return state;
    }
};
